import React, { useEffect } from 'react';
import { logger as log } from '@common/logger';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const deleteDraftContext = React.createContext({});
export let deleteDraftMachine: any;

const MODULE_NAME = 'machines.pageContent';

export const useSMDeleteDraft = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  deleteDraftMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(deleteDraftMachine);

  return {
    deleteDraftMachine,
    deleteDraftState: state,
    deleteDraftSend: send,
  };
};
